import { render } from "./SmoothepiTermsOfUseView.vue?vue&type=template&id=cf77b878"
import script from "./SmoothepiTermsOfUseView.vue?vue&type=script&lang=js"
export * from "./SmoothepiTermsOfUseView.vue?vue&type=script&lang=js"

import "./SmoothepiTermsOfUseView.vue?vue&type=style&index=0&id=cf77b878&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__